export enum StatusLevel {
  NEW = 'NEW',
  WANT_GO_LIVE = 'WANT_GO_LIVE',
  LIVE = 'LIVE',
  CANCELLED = 'CANCELLED',
  LIQUIDATION = 'LIQUIDATION',
  HOLD = 'HOLD'
}
